import service from '@/util/service';

// rewardPunish
export const getRewardPunishList = params => service.jsonGet('/api/business/rewardPunish/list', params);

export const getRewardPunishBase = params => service.jsonGet('/api/business/rewardPunish/baseInfo', params);

export const getRewardPunish = params => service.jsonGet('/api/business/rewardPunish/view', params);

export const addRewardPunish = params => service.jsonPost('/api/business/rewardPunish/save', params);



// WEBPACK FOOTER //
// ./src/api/rewardPunish/index.js